import { Component, Inject, OnInit } from '@angular/core';
import { IncidenciaModel } from '../../../models/IncidenciaModel';
import { IncidenciasService } from '../../../services/incidencias.service';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ErrorHelper } from '../../../models/ErrorHelper';
import { ModalDefaultComponent } from '../../controls/modal-default/modal-default.component';

@Component({
  selector: 'app-incidencia-close',
  templateUrl: './incidencia-close.component.html',
  styleUrls: ['./incidencia-close.component.scss']
})
export class IncidenciaCloseComponent implements OnInit {

  formGroup: FormGroup;
  tasacionId: number;
  model: IncidenciaModel = new IncidenciaModel();
  errorMessage: string = '';

  constructor(public dialogRef: MatDialogRef<IncidenciaCloseComponent>, private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private _avRoute: ActivatedRoute, private _incidenciaService: IncidenciasService, public matDialog: MatDialog) {
    if (data !== null) {
      this.tasacionId = data.id;
      if (data.model !== null)
        this.model = data.model;
    }
  }

  get cierre() {
    return this.formGroup.get('cierre');
  }

  ngOnInit() {
    this.buildForm();
    this.bindFromModel();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  buildForm() {
    this.formGroup = this._fb.group({
      id: 0,
      fechaCierre: new Date(),
      tasacionId: [this.tasacionId],
      cierre: ['', Validators.required]
    })
  }

  bindFromModel() {
    if(this.model == undefined) this.model = new IncidenciaModel();
    this.formGroup.patchValue({
      id: this.model.id,
      tasacionId: this.tasacionId
    });
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);
  }

  async onSubmit() {
    if (!this.formGroup.valid)
      return

    this.bindToModel();

    if (this.tasacionId != 0) {
      if (this.formGroup.value != null) {
        try {
          this._incidenciaService.closeIncidencia(this.model.tasacionId, this.model)
            .subscribe((data) => {
              this.closeDialog();
            })


        } catch (error) {
          let errorMessage = ErrorHelper.GetClientError(error);
          this.errorMessage = errorMessage;
        }
      }
    }
    let result = null
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  confirmAnswer() {
    if (this.formGroup.value.cierre != '') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.maxWidth = "350px"
      dialogConfig.data = {
        title: 'Atención',
        confirmText: 'Confirmar',
        // classColor: 'button-danger',
        message: `¿Está seguro de la incidencia está cerrada? Esto modificará el estado y finalizará la tramitación de la incidencia.`,
      };
      const ref = this.matDialog.open(ModalDefaultComponent, dialogConfig);
      ref.afterClosed().subscribe(async result => {
        if (result) {
          await this.onSubmit();
        } else {
          this.onNoClick();
        }
      });
    }

  }

}
